import React from "react";

export const InitialPasswordContainerContext = React.createContext();